/**
 * Nem engedjük a touchMove -ot, emiatt nincs Swipe / dragdrop, stb.
 * @param query - A query, amivel elkérjük az elemet, amire ezt kötni szeretnénk.
 */
export default function preventTouchMove (query: string): void {
  const el = document.querySelector(query)

  if (!el) {
    return
  }

  el.addEventListener('touchmove', (e) => {
    if (e.cancelable) {
      e.preventDefault()
    }

    e.stopPropagation()
    e.cancelBubble = true
    // https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
  }, { passive: false })
}
